module.exports = __webpack_public_path__ + "static/media/web-testing.8b643cde.svg";